gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

document.addEventListener("DOMContentLoaded", () => {

  /* ---------------------------------
     DEVICE & ACCESSIBILITY CHECKS
  ---------------------------------- */
  const isTouchDevice =
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  /* ---------------------------------
     SCROLL SMOOTHER (DESKTOP ONLY)
  ---------------------------------- */
  if (!isTouchDevice && !prefersReducedMotion) {
    ScrollSmoother.create({
      wrapper: "#smooth-wrapper",
      content: "#smooth-content",
      smooth: 2,
      normalizeScroll: true
    });
  }

  /* ---------------------------------
     HORIZONTAL GALLERIES
  ---------------------------------- */
  gsap.utils.toArray(".horiz-gallery-wrapper").forEach(section => {
    const strip = section.querySelector(".horiz-gallery-strip");
    if (!strip) return;

    let width = 0;
    let scroll = 0;

    function refresh() {
      width = strip.scrollWidth;
      scroll = Math.max(0, width - window.innerWidth);
    }

    refresh();

    gsap.to(strip, {
      x: () => -scroll,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "center center",
        end: () => `+=${width}`,
        scrub: true,
        pin: !isTouchDevice,
        invalidateOnRefresh: true
      }
    });

    ScrollTrigger.addEventListener("refreshInit", refresh);
  });

  /* ---------------------------------
     FADE PREVIEWS (GSAP – SEAMLESS)
  ---------------------------------- */
  if (!prefersReducedMotion) {
    document.querySelectorAll(".fade").forEach(fadeBlock => {
      const images = fadeBlock.querySelectorAll("img");
      if (images.length < 2) return;

      gsap.set(images, { opacity: 0 });
      gsap.set(images[0], { opacity: 1 });

      const tl = gsap.timeline({
        repeat: -1,
        defaults: { ease: "power1.inOut" }
      });

      images.forEach((img, i) => {
        const next = images[(i + 1) % images.length];

        tl.to(img, { opacity: 0, duration: 1 })
          .to(next, { opacity: 1, duration: 1 }, "<")
          .to({}, { duration: 2 });
      });
    });
  }

  /* ---------------------------------
     SCROLL INDICATOR
  ---------------------------------- */
  const backToTop = document.querySelector(".c-scroll-indicator--up");

  ScrollTrigger.create({
    trigger: ".hero",
    start: "bottom top",
    onEnter: () => {
      gsap.to(backToTop, {
        opacity: 1,
        y: 0,
        duration: 0.4,
        pointerEvents: "auto"
      });
    },
    onLeaveBack: () => {
      gsap.to(backToTop, {
        opacity: 0,
        y: 20,
        duration: 0.3,
        pointerEvents: "none"
      });
    }
  });

  backToTop.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });

  /* TOOLTIPS */

  // Create tooltip element
  const tooltip = document.createElement("div");
  tooltip.classList.add("tooltip");
  document.body.appendChild(tooltip);

  let active = false;

  // Select all images with alt
  const images = document.querySelectorAll("img[alt]");

  images.forEach((img) => {
    img.addEventListener("mouseenter", (e) => {
      const text = img.getAttribute("alt");

      if (!text) return;

      tooltip.textContent = text;
      active = true;

      gsap.to(tooltip, {
        opacity: 1,
        scale: 1,
        duration: 0.2,
        ease: "power3.out"
      });
    });

    img.addEventListener("mouseleave", () => {
      active = false;

      gsap.to(tooltip, {
        opacity: 0,
        scale: 0.9,
        duration: 0.2,
        ease: "power3.in"
      });
    });

    img.addEventListener("mousemove", (e) => {
      if (!active) return;

      gsap.to(tooltip, {
        x: e.clientX + 20,
        y: e.clientY + 20,
        duration: 0.2,
        ease: "power2.out"
      });
    });
  });

});
